import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/category', label: '电影分类' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于' },
];

export default function Navbar() {
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${
      isActive ? 'text-primary-700' : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-700 flex items-center justify-center">
              <i className="ri-film-line text-accent-400 text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950 tracking-tight">李采潭电影</span>
              <span className="text-[10px] text-foreground-500 tracking-[0.2em] mt-0.5">LEE CHAE-DAM FILMS</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.to === '/'} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={submitSearch} className="hidden md:flex items-center gap-2">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、简介…"
                className="w-48 lg:w-60 h-10 pl-9 pr-3 rounded-md bg-background-100 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition"
              />
            </div>
            <button
              type="submit"
              className="h-10 px-4 rounded-md bg-primary-700 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-800 transition-colors cursor-pointer"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 animate-fade-in">
          <form onSubmit={submitSearch} className="relative mb-3">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影片、简介…"
              className="w-full h-11 pl-9 pr-3 rounded-md bg-background-100 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                    isActive ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}